import { render, staticRenderFns } from "./CobrarDialog.vue?vue&type=template&id=93ab5024"
import script from "./CobrarDialog.vue?vue&type=script&lang=js"
export * from "./CobrarDialog.vue?vue&type=script&lang=js"
import style0 from "./CobrarDialog.vue?vue&type=style&index=0&id=93ab5024&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports